import withResolution from 'hoc/withResolution'
import DrawerContent from './common/DrawerContent'
import { DASHBOARD } from 'constants/breakpoints'

const DashboardDrawer = () => {
  return (
    <div className="h-screen w-[250px] shrink-0">
      <nav className="h-screen w-[250px] fixed top-0 left-0 z-[1200] bg-primary-800 overflow-auto">
        <DrawerContent />
      </nav>
    </div>
  )
}

export default withResolution(DASHBOARD)(DashboardDrawer)
